export class SetJobLocations {
    static readonly type = '[JobLocation] set';
    constructor(public data: any[]) { }
}
